/*
import flatTierIconW from "../../../callApp/src/static/img/white/flatTierIcon.svg";
import flatTierIconG from "../../../callApp/src/static/img/gray/flatTierIcon.svg";
import engineCheckIconW from "../../../callApp/src/static/img/white/engineCheckIcon.svg";
import engineCheckIconG from "../../../callApp/src/static/img/gray/engineCheckIcon.svg";
import emptyFuelIconW from "../../../callApp/src/static/img/white/emptyFuelIcon.svg";
import emptyFuelIconG from "../../../callApp/src/static/img/gray/emptyFuelIcon.svg";
*/

export const SERVICE_TYPES = {
    0: {
        name: 'Defekt',
/*
        image: {
            white: flatTierIconW,
            gray: flatTierIconG
        },
*/
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci, aliquam aliquid',
    },
    1: {
        name: 'Motor hiba',
        /*image: {
            white: engineCheckIconW,
            gray: engineCheckIconG
        },*/
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci, aliquam aliquid',
    },
    2: {
        name: 'Ures tank',
        /*image: {
            white: emptyFuelIconW,
            gray: emptyFuelIconG,
        },*/
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci, aliquam aliquid',
    },
}